export default "__VITE_ASSET__c9820feb__"